/// <reference types="./comments.d.mts" />
import * as $comment from "../../../common/data/comment.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $function from "../../../gleam_stdlib/gleam/function.mjs";
import * as $effect from "../../../lustre/lustre/effect.mjs";
import * as $state from "../../data/model/state.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $ask from "../../frontend/ask.mjs";
import * as $middleware from "../../frontend/middleware.mjs";
import { toList } from "../../gleam.mjs";

export function create_comment(c) {
  return $middleware.require_access_token(
    (access_token) => {
      return $effect.from(
        (_) => {
          return $function.tap(
            undefined,
            (_) => {
              let at = toList(["comment"]);
              let _pipe = $ask.to(new $ask.Heimdall(), at);
              let _pipe$1 = $ask.bearing(_pipe, access_token);
              let _pipe$2 = $ask.via(_pipe$1, new $http.Post());
              let _pipe$3 = $ask.with$(_pipe$2, $comment.encoder(c));
              let _pipe$4 = $ask.expect(_pipe$3, $comment.decoder());
              return $ask.run(_pipe$4);
            },
          );
        },
      );
    },
  );
}

export function update_comment(p) {
  return $middleware.require_access_token(
    (access_token) => {
      return $effect.from(
        (dispatch) => {
          return $function.tap(
            undefined,
            (_) => {
              let at = toList(["comment"]);
              let _pipe = $ask.to(new $ask.Heimdall(), at);
              let _pipe$1 = $ask.bearing(_pipe, access_token);
              let _pipe$2 = $ask.via(_pipe$1, new $http.Patch());
              let _pipe$3 = $ask.with$(
                _pipe$2,
                $comment.edition_payload_encoder(p),
              );
              let _pipe$4 = $ask.expect(_pipe$3, $comment.decoder());
              let _pipe$5 = $ask.notify(
                _pipe$4,
                (comment) => {
                  return dispatch(
                    new $msg.Comment(
                      new $msg.ApiUpdatedComments(toList([comment])),
                    ),
                  );
                },
              );
              return $ask.run(_pipe$5);
            },
          );
        },
      );
    },
  );
}

export function fetch_comments(_) {
  return $middleware.require_access_token(
    (access_token) => {
      return $effect.from(
        (dispatch) => {
          return $function.tap(
            undefined,
            (_) => {
              let at = toList(["comment", "list"]);
              let _pipe = $ask.to(new $ask.Heimdall(), at);
              let _pipe$1 = $ask.bearing(_pipe, access_token);
              let _pipe$2 = $ask.via(_pipe$1, new $http.Get());
              let _pipe$3 = $ask.expect(
                _pipe$2,
                $decode.list($comment.decoder()),
              );
              let _pipe$4 = $ask.notify(
                _pipe$3,
                (comments) => {
                  return dispatch(
                    new $msg.Comment(new $msg.ApiReturnedComments(comments)),
                  );
                },
              );
              return $ask.run(_pipe$4);
            },
          );
        },
      );
    },
  );
}

export function toggle_react_comment(comment_id, react) {
  return $middleware.require_access_token(
    (access_token) => {
      return $effect.from(
        (dispatch) => {
          return $function.tap(
            undefined,
            (_) => {
              let at = toList(["comment", "react", comment_id]);
              let _pipe = $ask.to(new $ask.Heimdall(), at);
              let _pipe$1 = $ask.bearing(_pipe, access_token);
              let _pipe$2 = $ask.via(_pipe$1, new $http.Post());
              let _pipe$3 = $ask.with$(_pipe$2, $comment.react_encoder(react));
              let _pipe$4 = $ask.expect(_pipe$3, $comment.decoder());
              let _pipe$5 = $ask.notify(
                _pipe$4,
                (comment) => {
                  return dispatch(
                    new $msg.Comment(
                      new $msg.ApiUpdatedComments(toList([comment])),
                    ),
                  );
                },
              );
              return $ask.run(_pipe$5);
            },
          );
        },
      );
    },
  );
}

export function archive_comment(comment_id) {
  return $middleware.require_access_token(
    (access_token) => {
      return $effect.from(
        (dispatch) => {
          return $function.tap(
            undefined,
            (_) => {
              let at = toList(["comment", "archive", comment_id]);
              let _pipe = $ask.to(new $ask.Heimdall(), at);
              let _pipe$1 = $ask.bearing(_pipe, access_token);
              let _pipe$2 = $ask.via(_pipe$1, new $http.Post());
              let _pipe$3 = $ask.expect(_pipe$2, $comment.decoder());
              let _pipe$4 = $ask.notify(
                _pipe$3,
                (comment) => {
                  return dispatch(
                    new $msg.Comment(
                      new $msg.ApiDeletedComments(toList([comment])),
                    ),
                  );
                },
              );
              return $ask.run(_pipe$4);
            },
          );
        },
      );
    },
  );
}

export function resolve_comment(comment_id) {
  return $middleware.require_access_token(
    (access_token) => {
      return $effect.from(
        (dispatch) => {
          return $function.tap(
            undefined,
            (_) => {
              let at = toList(["comment", "resolve", comment_id]);
              let _pipe = $ask.to(new $ask.Heimdall(), at);
              let _pipe$1 = $ask.bearing(_pipe, access_token);
              let _pipe$2 = $ask.via(_pipe$1, new $http.Post());
              let _pipe$3 = $ask.expect(_pipe$2, $comment.decoder());
              let _pipe$4 = $ask.notify(
                _pipe$3,
                (comment) => {
                  return dispatch(
                    new $msg.Comment(
                      new $msg.ApiUpdatedComments(toList([comment])),
                    ),
                  );
                },
              );
              return $ask.run(_pipe$4);
            },
          );
        },
      );
    },
  );
}
